class GIconMap extends HTMLElement {
  connectedCallback() {
    this.innerHTML = '<svg class="g-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path d="M16.8 50c-.1 0-.2 0-.3-.1L.2 38.2c-.1-.1-.2-.2-.2-.4V.5C0 .3.1.1.3.1c.1-.1.3-.1.5 0l16 11.5L32.9.1c.2-.1.4-.1.6 0l16.3 11.7c.1.1.2.2.2.4v37.3c0 .2-.1.4-.3.4-.2.1-.4.1-.5 0l-16-11.5-16.1 11.5c-.1.1-.2.1-.3.1zm.5-37.5v36.1l15.4-11V1.5l-15.4 11zm16.4 25l15.3 11v-36l-15.3-11v36zM1 37.5l15.3 11v-36L1 1.5v36z"/></svg>';
  }
}

if (!customElements.get('g-icon-map')) {
  customElements.define('g-icon-map', GIconMap);
}
